var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { UiIncremental } from '@claims-ia/design-system';
import BreakInDamageDescriptionSectionCard from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionSectionCard.vue';
import BreakInDamageDescriptionStep from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionStep.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import BreakInDamageCheckBox from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageCheckBox.vue';
import BreakInDamageDescriptionSubSection from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionSubSection.vue';
import { parseLength } from '@declaration/helpers/typeFormatters';
import { METAL_FRENCH_WINDOW_IMPACTS_NUMBER, PVC_FRENCH_WINDOW_IMPACTS_NUMBER, WOOD_FRENCH_WINDOW_IMPACTS_NUMBER, } from '@shared/constants/breakInDamages/FrenchWindowConstants';
import { Material } from '@shared/types/api/breakInDamage';
const layout = namespace('layout');
const breakInDamage = namespace('breakInDamage');
let FrenchWindowImpacts = class FrenchWindowImpacts extends Vue {
    constructor() {
        super(...arguments);
        this.parseLength = parseLength;
        this.showValidation = false;
    }
    get change() {
        return this.changeGetter(this.changeKey);
    }
    get breakInDamage() {
        return this.change.data;
    }
    get validation() {
        return this.validationGetter(this.changeKey);
    }
    get isValid() {
        return !this.validation.fieldHasViolations('numberOfImpacts');
    }
    update(data) {
        this.updateBreakInDamage({ changeKey: this.changeKey, data });
    }
    save() {
        this.$emit('goToNextStep');
    }
    revealValidation() {
        this.$store.dispatch('error/add', this.$tc('error.form.please_validate_message'));
        this.validateBreakInDamage(this.changeKey);
        this.showValidation = true;
    }
    get numberOfImpacts() {
        if (this.breakInDamage.material === Material.Wood) {
            return WOOD_FRENCH_WINDOW_IMPACTS_NUMBER;
        }
        if (this.breakInDamage.material === Material.Metal) {
            return METAL_FRENCH_WINDOW_IMPACTS_NUMBER;
        }
        if (this.breakInDamage.material === Material.PVC) {
            return PVC_FRENCH_WINDOW_IMPACTS_NUMBER;
        }
        return null;
    }
};
__decorate([
    layout.State('color')
], FrenchWindowImpacts.prototype, "color", void 0);
__decorate([
    breakInDamage.Getter('change')
], FrenchWindowImpacts.prototype, "changeGetter", void 0);
__decorate([
    breakInDamage.Action('updateDamage')
], FrenchWindowImpacts.prototype, "updateBreakInDamage", void 0);
__decorate([
    breakInDamage.Getter('validation')
], FrenchWindowImpacts.prototype, "validationGetter", void 0);
__decorate([
    breakInDamage.Action('validateAndRevealDamages')
], FrenchWindowImpacts.prototype, "validateBreakInDamage", void 0);
FrenchWindowImpacts = __decorate([
    Component({
        components: {
            UiIncremental,
            BreakInDamageDescriptionStep,
            BreakInDamageDescriptionSectionCard,
            RadioPrimaryButton,
            BreakInDamageCheckBox,
            BreakInDamageDescriptionSubSection,
        },
        props: {
            changeKey: { type: [String, Number], default: null },
            isFinalStep: { type: Boolean, default: false },
            isSaving: { type: Boolean, default: false },
        },
    })
], FrenchWindowImpacts);
export default FrenchWindowImpacts;
